// Small read helpers over useEdition() for hotel wording on shared pages (PLAN.md §5.1, owner A). Loading and
// error read as "not a hotel", so agencies never see a hotel text flash and their pages stay as they are.
import type { EditionModule } from "@shared/edition";
import { useEdition } from "./edition";

export function useIsHotelEdition(): boolean {
  const state = useEdition();
  return state.status === "ready" && state.edition.kind === "hotel";
}

/** Hotel with this module live (e.g. 'marke' moves the brand kit from the profile to /marke). */
export function useHotelModule(module: EditionModule): boolean {
  const state = useEdition();
  return state.status === "ready" && state.edition.kind === "hotel" && state.edition.modules.includes(module);
}
